import { render, staticRenderFns } from "./AmazeEditor.vue?vue&type=template&id=6389b5dd&scoped=true"
import script from "./AmazeEditor.vue?vue&type=script&lang=js"
export * from "./AmazeEditor.vue?vue&type=script&lang=js"
import style0 from "./AmazeEditor.vue?vue&type=style&index=0&id=6389b5dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6389b5dd",
  null
  
)

export default component.exports